module.exports = __webpack_public_path__ + "cd87c2e33821319665e881e350fe2af3.jpg";